/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerReadQueryResponse, BidLevelingsControllerReadPathParams, BidLevelingsControllerReadQueryParams, BidLevelingsControllerRead400, BidLevelingsControllerRead401, BidLevelingsControllerRead403, BidLevelingsControllerRead404 } from "../../models/bidsController/BidLevelingsControllerRead";

function getBidLevelingsControllerReadUrl(id: BidLevelingsControllerReadPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/bid-levelings/${id}` as const }  
  return res
}

/**
 * @description Pass include=rows,bidders,bidders.currentSubmission,cells,questions,suggestions,pendingSubmissions to get the whole grid in one request.
 * @summary Read a trade's grid
 * {@link /api/v1/bid-levelings/:id}
 */
export async function bidLevelingsControllerRead(id: BidLevelingsControllerReadPathParams["id"], params?: BidLevelingsControllerReadQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidLevelingsControllerReadQueryResponse, ResponseErrorConfig<BidLevelingsControllerRead400 | BidLevelingsControllerRead401 | BidLevelingsControllerRead403 | BidLevelingsControllerRead404>, unknown>({ method : "GET", url : getBidLevelingsControllerReadUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}